import styled from "@emotion/styled";

export const FooterSection = styled.footer`
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 400;
  color: white;
  background-color: #000;
  padding: 8px;
  padding-top: 80px;
  max-width: 480px;
  margin: 0 auto;
  margin-bottom: 150px;

  [data-footer-copyright] {
    padding-top: 104px;
    padding-bottom: 56px;
    font-size: 14px;
    line-height: 18px;
  }

  .footer__store {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    padding-top: 249px;
    padding-bottom: 240px;

    image-rendering: -webkit-optimize-contrast;

    .footer__store--logo {
      width: 148px;
      height: 148px;
    }

    .footer__store__apps {
      margin-top: 73px;

      .app {
        width: 178px;
        height: 62px;
      }
    }
  }

  .footer__information {
    display: flex;
    flex-direction: column;
    width: 100%;

    h5 {
      font-weight: 700;
      font-size: 20px;
      color: white;
      margin-bottom: 32px;
    }

    li {
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.02em;
    }

    p {
      font-size: 11px;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0.02em;
      color: #aeaeb2;
    }

    [data-company-address] {
      li:first-of-type {
        margin: 10px 0;
      }
    }

    [data-company-learn-more] {
      .info-privacy {
        color: white;
        margin-top: 10px;
      }
      .info-career {
        display: none;
      }

      a {
        margin-bottom: 10px;
      }
    }

    .info-tos {
      margin-top: 40px;
    }

    .info-privacy {
      margin-bottom: 40px;
    }
  }
`;
